import React from "react";
import Select from "react-select";
import "../../style/SelectMenu.css";

function SelectMenu() {
  // Options for the multiselect
  const multiOptions = [
    { value: "1", label: "Books" },
    { value: "2", label: "Movies, Music & Games" },
    { value: "3", label: "Electronics & Computers" },
    { value: "4", label: "Home, Garden & Tools" },
    { value: "5", label: "Health & Beauty" },
    { value: "6", label: "Toys, Kids & Baby" },
    { value: "7", label: "Clothing & Jewelry" },
    { value: "8", label: "Sports & Outdoors" },
  ];

  // Options for the single select
  const singleOptions = [
    { value: "1", label: "Dr." },
    { value: "2", label: "Mr." },
    { value: "3", label: "Mrs." },
    { value: "4", label: "Ms." },
    { value: "5", label: "Prof." },
    { value: "6", label: "Other" },
  ];

  return (
    <div className="select-container col-md-8 col-lg-8 col-xl-8 mx-auto">
      <h1 className="select-title mb-3 fw-normal border-bottom pb-2 mb-4">
        Select Menu
      </h1>

      <div className="mb-5">
        <h6 className="mt-4 text-left mb-3">Multiselect drop down</h6>
        <div className="col-md-12">
          <label className="multi-label text-muted small">Multi-select</label>
          <Select
            isMulti
            name="categories"
            options={multiOptions}
            className="basic-multi-select"
            classNamePrefix="select"
            placeholder="Select..."
            // Setting default values to match your image
            defaultValue={[multiOptions[1], multiOptions[3], multiOptions[4]]}
          />
        </div>
      </div>

      <div>
        <h6 className="mt-4 text-left mb-3">Select One</h6>
        <div className="col-md-12">
          <Select
            name="title"
            options={singleOptions}
            className="basic-single"
            classNamePrefix="select"
            placeholder="Pick one title"
            isClearable={true}
          />
        </div>
      </div>
    </div>
  );
}

export default SelectMenu;
